import { render, staticRenderFns } from "./StepReceivedLastDose.vue?vue&type=template&id=10f180a0&"
import script from "./StepReceivedLastDose.vue?vue&type=script&lang=js&"
export * from "./StepReceivedLastDose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports